/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  // {
  //     to: "/accounts2",
  //     icon: "mdi-account",
  //     text: "Accounts2"
  // },
  {
    icon: "mdi-account",
    text: "Accounts & Activity",
    sublinks: [
      {
        to: "/accounts",
        icon: "mdi-account",
        text: "Accounts",
      },
      {
        to: "/site-visits",
        icon: "mdi-search-web",
        text: "Site Visits",
      },
      {
        to: "/ivr-calls",
        icon: "mdi-phone",
        text: "IVR Calls",
      },
    ],
  },
  {
    icon: "mdi-currency-usd",
    text: "Payments",
    sublinks: [
      {
        to: "/payments",
        id: "payments",
        icon: "mdi-currency-usd",
        text: "Payments",
      },
      {
        to: "/schedules",
        icon: "mdi-clock-outline",
        text: "Schedules",
      },
      {
        to: "/schedule-details",
        icon: "mdi-folder-clock-outline",
        text: "Schedule Details",
      },
      {
        to: "/payment-pickups",
        icon: "mdi-currency-usd",
        text: "Payment Pickups",
      },
      {
        to: "/unprocessed-payments",
        icon: "mdi-clock-outline",
        text: "Unprocessed Payments",
      },
      {
        to: "/butcher-rewards",
        icon: "mdi-wallet-giftcard",
        text: "Butcher Rewards",
      },
    ],
  },
  {
    icon: "mdi-dots-horizontal-circle",
    text: "Other",
    sublinks: [
      {
        to: "/publications",
        id: "publications",
        icon: "mdi-file-upload",
        text: "Publications",
      },
      {
        to: "/file-downloads",
        id: "file-downloads",
        icon: "mdi-download-multiple",
        text: "Downloads",
      },
      {
        to: "/credit-card-charges",
        icon: "mdi-credit-card-multiple",
        text: "Credit Card Charges",
      },
      {
        to: "/shared-files",
        icon: "mdi-file-move",
        text: "Shared Files",
      },
      {
        to: "/files-shared-with-user",
        icon: "mdi-file-account",
        text: "Files Shared With Me",
      },
      {
        to: "/chol-hamoed-program-students",
        icon: "mdi-human-child",
        text: "Chol Hamoed Program Students",
      },
      {
        to: "/chol-hamoed-program-reports",
        icon: "mdi-comment-account",
        text: "Chol Hamoed Program",
      },
      {
        to: "/chol-hamoed-program-totals",
        icon: "mdi-chart-bar",
        text: "Chol Hamoed Program Totals",
      },
    ],
  },
  {
    icon: "mdi-human-child",
    text: "Students",
    sublinks: [
      {
        to: "/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/students/buildings",
        icon: "mdi-domain",
        text: "Buildings",
      },
      {
        to: "/branches",
        icon: "mdi-account-group",
        text: "Branches",
      },
      {
        to: "/classes",
        icon: "mdi-chair-school",
        text: "Classes",
      },
      {
        to: "/student-class-info",
        icon: "mdi-file-account",
        text: "Students Class Info",
      },
      {
        to: "/kita-alef-messages",
        icon: "mdi-message-processing",
        text: "Kita Alef Messages",
      },
      {
        to: "/special-needs-students",
        icon: "mdi-human-child",
        text: "Special Needs Students",
      },
      {
        to: "/student-lookup",
        icon: "mdi-account-search",
        text: "Students Lookup",
      },
      {
        to: "/student-attendance-cards",
        icon: "mdi-credit-card-multiple",
        text: "Student Attendance Cards",
      },
      {
        to: "/attendance-scans",
        icon: "mdi-barcode-scan",
        text: "Attendance Scans",
      },
      {
        to: "/attendance-daily-report",
        icon: "mdi-account-box-multiple",
        text: "Attendance Daily Report",
      },
      {
        to: "/student-voucher-status",
        icon: "mdi-ticket-account",
        text: "Student Voucher Status",
      },
    ],
  },
  {
    icon: "mdi-chair-school",
    text: "School",
    sublinks: [
      {
        to: "/student-calls",
        icon: "mdi-phone",
        text: "Calls",
      },
      {
        to: "/school-phones",
        icon: "mdi-phone-classic",
        text: "Phones",
      },
      // {
      //     to: "/teacher-settings",
      //     icon: "mdi-settings",
      //     text: "Teacher Settings",
      // },
      {
        to: "/kesher-employees",
        icon: "mdi-account-supervisor",
        text: "Kesher Employees",
      },
      {
        to: "/broadcast-contacts",
        icon: "mdi-account-group",
        text: "Broadcast Contacts",
      },
      {
        to: "/tips",
        icon: "mdi-currency-usd",
        text: "Tips",
      },
      {
        to: "/tip-payments",
        icon: "mdi-currency-usd",
        text: "Tip Payments",
      },
      {
        to: "/tip-transactions",
        icon: "mdi-currency-usd",
        text: "Tip Transactions",
      },
      {
        to: "/teacher-relations",
        icon: "mdi-all-inclusive",
        //arrow-expand-horizontal infinity
        text: "Teacher Relations",
      },
      {
        to: "/appointments",
        icon: "mdi-calendar-clock",
        text: "Appointments",
      },
      {
        to: "/not-assined-students",
        icon: "mdi-human-child",
        text: "Not Assined Students",
      },
      {
        to: "/school/menahal-broadcasts",
        icon: "mdi-access-point",
        text: "Menahal Broadcast",
      },
    ],
  },
  {
    icon: "mdi-bus",
    text: "Transportation",
    sublinks: [
      {
        to: "/transportation/buses",
        icon: "mdi-bus-side",
        text: "Buses",
      },
      {
        to: "/transportation/drivers",
        icon: "mdi-account-multiple",
        text: "Drivers",
      },
      {
        to: "/transportation/routes",
        icon: "mdi-routes",
        text: "Routes",
      },
      {
        to: "/transportation/routes-report",
        icon: "mdi-chart-gantt",
        text: "Routes Report",
      },
      {
        to: "/transportation/driver-absent",
        icon: "mdi-account-remove",
        text: "Absent Reports",
      },
      {
        to: "/transportation/routes-calander",
        icon: "mdi-calendar",
        text: "Routes Absence Calendar",
      },
      {
        to: "/transportation/bus-changes",
        icon: "mdi-bus-alert",
        text: "Bus Changes",
      },
      {
        to: "/transportation/bus-change-requests",
        icon: "mdi-message-alert",
        text: "Bus Change Requests",
      },
    ],
  },
  {
    icon: "mdi-map-marker-circle",
    text: "Geo",
    sublinks: [
      {
        to: "/geo/geo-students",
        icon: "mdi-human-child",
        text: "Geo Students",
      },
      {
        to: "/geo/geo-map-view",
        icon: "mdi-map",
        text: "Geo Map View",
      },
    ],
  },
  {
    icon: "mdi-account-edit",
    text: "Registration",
    sublinks: [
      {
        to: "/documents",
        id: "documents",
        icon: "mdi-file-multiple",
        text: "Documents",
      },
      {
        to: "/kollel-applications",
        icon: "mdi-file-document",
        text: "Kollel Applications",
      },
      {
        to: "/kollel-application-logs",
        icon: "mdi-folder-search",
        text: "Kollel Application Logs",
      },
      {
        to: "/vm-forms",
        icon: "mdi-file-document",
        text: "VM Forms",
      },
      {
        to: "/vm-form-logs",
        icon: "mdi-folder-search",
        text: "VM Form Logs",
      },
      {
        to: "/vm-account-status",
        icon: "mdi-account-supervisor-circle",
        text: "VM Account Status",
      },
      {
        to: "/new-family-applications",
        icon: "mdi-account-box-multiple",
        text: "New Family Applications",
      },
      {
        to: "/applicant-students",
        icon: "mdi-folder-edit",
        text: "Applicant Students",
      },
      {
        to: "/new-child-appointments",
        icon: "mdi-calendar-clock",
        text: "New Child Appointments",
      },
      {
        to: "/hs-new-students",
        icon: "mdi-human-child",
        text: "HS New Students",
      },
      {
        to: "/hs-students-import",
        icon: "mdi-account-multiple",
        text: "HS Imported Students",
      },
      {
        to: "/hs-matched-students",
        icon: "mdi-account-check",
        text: "HS Matched Students",
      },
      {
        to: "/hs-students-view",
        icon: "mdi-account-box-multiple",
        text: "HS Students View",
      },
      {
        to: "/75-enrollments",
        icon: "mdi-account-box-outline",
        text: "75 Enrollments",
      },
    ],
  },
  {
    icon: "mdi-account-switch",
    text: "Communications",
    sublinks: [
      {
        to: "/communications/sms-pending-messages",
        icon: "mdi-message-processing",
        text: "Pending Messages",
      },
      {
        to: "/communications/account-messages",
        icon: "mdi-message-processing",
        text: "All Messages",
      },
      {
        to: "/communications/pending-callback-requests",
        icon: "mdi-phone-return",
        text: "Pending Callback Requests",
        subText: "0",
      },
      {
        to: "/communications/callback-requests",
        icon: "mdi-phone-return",
        text: "All Callback Requests",
      },
      {
        to: "/contactUs",
        id: "contactUs",
        icon: "mdi-email",
        text: "Contact Us",
      },
      {
        to: "/communications/emails",
        icon: "mdi-email",
        text: "Emails",
      },
      {
        to: "/communications/calls",
        icon: "mdi-phone",
        text: "Calls",
      },
      {
        to: "/communications/tuition-discount-requests",
        icon: "mdi-sale",
        text: "Discount Requests",
      },
      {
        to: "/communications/callback-summary",
        icon: "mdi-table",
        text: "Callback Summary",
      },
      {
        to: "/communications/queue-report",
        icon: "mdi-account-multiple",
        text: "Queue Report",
      },
      {
        to: "/communications/feedback",
        icon: "mdi-message-alert",
        text: "Hakol 311",
      },
    ],
  },
  {
    icon: "mdi-food",
    text: "Food Distribution",
    sublinks: [
      {
        to: "/food-distribution/families",
        icon: "mdi-account-group",
        text: "Families",
      },
      {
        to: "/food-distribution/siblings",
        icon: "mdi-human-male-boy",
        text: "Siblings",
      },
      {
        to: "/food-distribution/distributions",
        icon: "mdi-truck-delivery",
        text: "Distributions",
      },
      {
        to: "/food-distribution/routes",
        icon: "mdi-routes",
        text: "Routes",
      },
      {
        to: "/food-distribution/scans",
        icon: "mdi-barcode-scan",
        text: "Scans",
      },
      {
        to: "/food-distribution/feedback",
        icon: "mdi-message-alert",
        text: "Feedback",
      },
      {
        to: "/food-distribution/changes",
        icon: "mdi-account-edit",
        text: "Enrollment Changes",
      },
      {
        to: "/food-distribution/logs",
        icon: "mdi-file-document",
        text: "Logs",
      },
    ],
  },
  {
    icon: "mdi-vote",
    text: "Votes",
    sublinks: [
      {
        to: "/voting-master-list",
        icon: "mdi-account",
        text: "Master List",
      },
      {
        to: "/doe",
        icon: "mdi-account-multiple",
        text: "DOE",
      },
      {
        to: "/yg-students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/voting-reg-notes",
        icon: "mdi-note-multiple",
        text: "Notes",
      },
      {
        to: "/voting-reg-auto-match",
        icon: "mdi-account-switch",
        text: "Auto Match",
      },
      {
        to: "/voting-reg-forms",
        icon: "mdi-file-document",
        text: "Registration Forms",
      },
      {
        to: "/accounts-voting-registration-status",
        icon: "mdi-account-search-outline",
        text: "UTA Accounts",
      },
      {
        to: "/voting-registration-submissions",
        icon: "mdi-arrow-up-box",
        text: "Registration Submission Requests",
      },
      {
        to: "/online-voting-registration-forms",
        icon: "mdi-account-box-multiple",
        text: "Online Registration Forms",
      },
    ],
  },
  {
    icon: "mdi-bullhorn-outline",
    text: "Broadcast",
    sublinks: [
      {
        to: "/phone",
        icon: "mdi-phone",
        text: "Phone Numbers",
      },
      {
        to: "/sms",
        icon: "mdi-message-processing",
        text: "SMS",
      },
      {
        to: "/calls",
        icon: "mdi-phone-log",
        text: "Calls",
      },
      {
        to: "/broadcast-dashboard",
        icon: "mdi-access-point",
        text: "Broadcast List",
      },
      {
        to: "/audio-library",
        icon: "mdi-animation-play",
        text: "Audio Library",
      },
      {
        to: "/surveys",
        icon: "mdi-comment-question",
        text: "Survey",
      },
      {
        to: "/broadcast-notifications",
        icon: "mdi-calendar-clock",
        text: "Broadcast Notifications",
      },
    ],
  },
  {
    icon: "mdi-phone-in-talk",
    text: "Camp Calling Card",
    sublinks: [
      {
        to: "/camp-calling-card/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/camp-calling-card/calls",
        icon: "mdi-phone",
        text: "Calls",
      },
      {
        to: "/camp-calling-card/camp-settings",
        icon: "mdi-settings",
        text: "Settings",
      },
      {
        to: "/camp-calling-card/signalwire-calls",
        icon: "mdi-file-document",
        text: "Call Logs",
      },
      {
        to: "/camp-calling-card/call-stats",
        icon: "mdi-chart-bar",
        text: "Call Stats",
      },
    ],
  },
  {
    icon: "mdi-home",
    text: "Lapidus",
    sublinks: [
      {
        to: "/lapidus/billing",
        icon: "mdi-account",
        text: "Country Billing",
      },
      {
        to: "/lapidus/accounts",
        icon: "mdi-account",
        text: "Cheider Billing",
      },
      {
        to: "/lapidus/daycamp-accounts",
        icon: "mdi-account",
        text: "Day Camp Billing",
      },
      {
        to: "/lapidus/payments",
        icon: "mdi-currency-usd",
        text: "Payments",
      },
      {
        to: "/unprocessed-payments/LAPIDUS",
        basePath: "/unprocessed-payments",
        icon: "mdi-clock-outline",
        text: "Unprocessed Payments",
      },
      {
        to: "/lapidus/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/lapidus/documents",
        icon: "mdi-file-multiple",
        text: "Documents",
      },
      {
        to: "/lapidus/classes",
        icon: "mdi-chair-school",
        text: "Classes",
      },
      {
        to: "/lapidus/class-summary",
        icon: "mdi-chair-school",
        text: "Class Summary",
      },
      {
        to: "/lapidus/residents",
        icon: "mdi-home-variant",
        text: "Lapidus Residents",
      },
    ],
  },
  {
    icon: "mdi-currency-usd",
    text: "YK Camp Billing",
    sublinks: [
      {
        to: "/ykc/accounts",
        icon: "mdi-account",
        text: "Accounts",
      },
      {
        to: "/ykc/accounts-extended",
        icon: "mdi-account",
        text: "Accounts Extended",
      },
      {
        to: "/ykc/payments",
        icon: "mdi-currency-usd",
        text: "Payments",
      },
      {
        to: "/ykc/payment-details",
        icon: "mdi-currency-usd",
        text: "Payment Receipts",
      },
      {
        to: "/unprocessed-payments/YK",
        basePath: "/unprocessed-payments",
        icon: "mdi-clock-outline",
        text: "Unprocessed Payments",
      },
      {
        to: "/ykc/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/ykc/documents",
        icon: "mdi-file-multiple",
        text: "Documents",
      },
      {
        to: "/ykc/recent-pages",
        icon: "mdi-account-multiple",
        text: "Recent Accounts",
      },
      {
        to: "/ykc/notes",
        icon: "mdi-note-multiple",
        text: "Notes",
      },
      {
        to: "/ykc/billing-report",
        icon: "mdi-chart-bar",
        text: "Billing Report",
      },
      {
        to: "/ykc/billing-summary",
        icon: "mdi-chart-bar",
        text: "Billing Summary",
      },
    ],
  },
  {
    icon: "mdi-package-variant-closed",
    text: "YK Camp Distribution",
    sublinks: [
      {
        to: "/ykc/camp-families",
        icon: "mdi-account-group",
        text: "Camp Families",
      },
      {
        to: "/ykc/camp-distribution-requests",
        icon: "mdi-message-alert",
        text: "Camp Distribution Requests",
      },
      {
        to: "/ykc/camp-menu-summary",
        icon: "mdi-chart-bar",
        text: "Camp Menu Summary",
      },
      {
        to: "/ykc/camp-menu-summary-family-report",
        icon: "mdi-chart-gantt",
        text: "Menu Summary Family Report",
      },
      {
        to: "/ykc/camp-distribution-logs",
        icon: "mdi-folder-search",
        text: "Camp Distribution Logs",
      },
      {
        to: "/ykc/camp-distribution-ivr-calls",
        icon: "mdi-phone",
        text: "Camp Distribution IVR Calls",
      },
      {
        to: "/ykc/camp-distributions",
        icon: "mdi-package-variant",
        text: "Camp Distributions",
      },
      {
        to: "/ykc/camp-menu-items",
        icon: "mdi-food",
        text: "Camp Menu Items",
      },
      {
        to: "/ykc/camp-distribution-default-totals",
        icon: "mdi-poll",
        text: "Camp Distribution Default Totals",
      },
    ],
  },

  {
    icon: "mdi-account-supervisor",
    text: "YK",
    sublinks: [
      {
        to: "/yk-students",
        icon: "mdi-account-group",
        text: "Students",
      },
      {
        to: "/yk-recordings",
        icon: "mdi-volume-high",
        text: "Recordings",
      },
    ],
  },
  {
    icon: "mdi-currency-usd",
    text: "Dinner",
    sublinks: [
      {
        to: "/dinner/donors",
        icon: "mdi-account",
        text: "Donors",
      },
      {
        to: "/dinner/ivr-calls",
        icon: "mdi-phone",
        text: "IVR Calls",
      },
      {
        to: "/dinner/site-visits",
        icon: "mdi-search-web",
        text: "Site Visits",
      },
      {
        to: "/dinner/payments",
        icon: "mdi-currency-usd",
        text: "Payments",
      },
      {
        to: "/dinner/news",
        icon: "mdi-newspaper",
        text: "Dinner News",
      },
      {
        to: "/dinner/kapures",
        icon: "fa-kiwi-bird",
        text: "Kapures",
      },
      {
        to: "/dinner/year-book-ad-payments",
        icon: "mdi-book-open-page-variant",
        text: "Year Book AD Payments",
      },
      {
        to: "/dinner/kapures-totals",
        icon: "mdi-chart-bar",
        text: "Kapures Total",
      },
      {
        to: "/alumini",
        icon: "mdi-school",
        text: "Alumini",
      },
    ],
  },
  {
    icon: "mdi-account-box-multiple",
    text: "Genvite",
    sublinks: [
      {
        to: "/genvite/persons",
        icon: "mdi-account",
        text: "Genvite Persons",
      },
      {
        to: "/genvite/conflicts",
        icon: "mdi-account-switch",
        text: "Genvite Conflicts",
      },
      {
        to: "/genvite/conflict-details",
        icon: "mdi-folder-account",
        text: "Genvite Conflict Details",
      },
    ],
  },
  {
    icon: "mdi-desktop-classic",
    text: "Help Desk",
    sublinks: [
      {
        to: "/helpdesk/requests",
        icon: "mdi-help-circle-outline",
        text: "Support Tickets",
      },
      {
        to: "/helpdesk/technician/requests",
        icon: "mdi-help-circle-outline",
        text: "Technician Mode Tickets",
      },
      {
        to: "/helpdesk/manageengine-users",
        icon: "mdi-help-circle-outline",
        text: "Manageengine Users",
      },
    ],
  },
  {
    icon: "mdi-domain",
    text: "DediPro",
    sublinks: [
      {
        to: "/dediPro/dedication-items",
        icon: "mdi-domain",
        text: "Items",
      },
      {
        to: "/dediPro/dedication-sales",
        icon: "mdi-domain",
        text: "Sales",
      },
    ],
  },
  {
    icon: "mdi-cash-multiple",
    text: "Purim",
    sublinks: [
      {
        to: "/purim/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/purim/transactions",
        icon: "mdi-currency-usd",
        text: "Transactions",
      },
      {
        to: "/purim/tracking-details",
        icon: "mdi-account-details",
        text: "Tracking Details",
      },
      {
        to: "/purim/gifts",
        icon: "mdi-gift",
        text: "Gifts",
      },
      {
        to: "/purim/totals",
        icon: "mdi-chart-bar",
        text: "Totals",
      },
      {
        to: "/purim/settings",
        icon: "mdi-settings",
        text: "Settings",
      },
    ],
  },
  // {
  //     icon: "mdi-eyedropper",
  //     text: "Covid 19 Test",
  //     sublinks: [
  //         {
  //             to: "/covid-test/test-entry",
  //             icon: "mdi-account",
  //             text: "Student Entry",
  //         },
  //     ],
  // },
  // {
  //     icon: "mdi-account-search",
  //     text: "Covid 19 Screening",
  //     sublinks: [
  //         {
  //             to: "/covid-screening/covid-screening-students",
  //             icon: "mdi-account-search",
  //             text: "Student Status",
  //         },
  //         {
  //             to: "/covid-screening/covid-screening-logs",
  //             icon: "mdi-file-document",
  //             text: "Logs",
  //         },
  //         {
  //             to: "/covid-screening/covid-screening-sms-sessions",
  //             icon: "mdi-message-processing",
  //             text: "Sms Sessions",
  //         },
  //         // {
  //         //     to: "/covid-screening/covid-screening-status",
  //         //     icon: "mdi-account-search",
  //         //     text: "Account Status",
  //         // },
  //     ],
  // },
  {
    icon: "mdi-chair-school",
    text: "Day Camp",
    sublinks: [
      {
        to: "/day-camp/status-lookup",
        icon: "mdi-human-child",
        text: "Students Status",
      },
    ],
  },
  {
    icon: "mdi-home-map-marker",
    text: "Girls Camp",
    sublinks: [
      {
        to: "/girls-camp/accounts",
        icon: "mdi-account",
        text: "Accounts",
      },
      {
        to: "/girls-camp/payments",
        icon: "mdi-currency-usd",
        text: "Payments",
      },
      {
        to: "/girls-camp/students",
        icon: "mdi-human-child",
        text: "Students",
      },
      {
        to: "/girls-camp/covid-labels",
        icon: "mdi-label",
        text: "Covid-19 Labels",
      },
      {
        to: "/girls-camp/classes",
        icon: "mdi-chair-school",
        text: "Classes & Bunks",
      },
      {
        to: "/girls-camp/class-summary",
        icon: "mdi-chair-school",
        text: "Class Summary",
      },
    ],
  },
  // {
  //     icon: "mdi-content-copy",
  //     text: "Camp Petitions",
  //     sublinks: [
  //         {
  //             to: "/camp-petition/submissions",
  //             icon: "mdi-content-copy",
  //             text: "Submissions",
  //         },
  //         {
  //             to: "/camp-petition/sms",
  //             icon: "mdi-comment-text",
  //             text: "SMS Sessions",
  //         },
  //     ],
  // },
  {
    icon: "mdi-settings",
    text: "Settings",
    sublinks: [
      {
        to: "/settings/users",
        icon: "mdi-account-outline",
        text: "Users",
      },
      {
        to: "/settings/roles",
        icon: "mdi-key",
        text: "Roles",
      },
      {
        to: "/settings/settings",
        icon: "mdi-settings",
        text: "Settings",
      },
      {
        to: "/navigation-settings",
        icon: "mdi-format-list-bulleted",
        text: "Navigation Settings",
      },
    ],
  },
];
